module.exports = __webpack_public_path__ + "static/img/Keaon-Kolomatangi.e10876b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Keaon-Kolomatangi.jpg
// module id = eXQ2
// module chunks = 0